import module from './change-password.module';
import './change-password.controller';
import './change-password.style.scss';

export default module.name;